/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
import { getValue } from 'globals/utils';
import React, { Component, Suspense, lazy } from 'react';
import { WithRouterHooks } from 'withFunctionHooks';

class MetaPyra extends Component {
     constructor(props) {
          super(props);
          const { match } = this.props;
          this.state = {isLoggedIn:false,metaPyraUrl:"" };
          this.checkIfLoggedIn();
     }

     checkIfLoggedIn = () => {
          getValue().then(async (payloadData) => {
               if (payloadData && payloadData.isloggedin && payloadData.metaPyraUrl && payloadData.metaPyraUrl!="") {
                    this.setState({metaPyraUrl: payloadData.metaPyraUrl ,isLoggedIn:true});
               } else {
                    this.setState({isLoggedIn:false});
               }
          });
     }

     render = () => {
          return (<>
               {this.state.isLoggedIn && <button className="metapyra-button" onClick={()=>{
                    window.open(
                         this.state.metaPyraUrl, "_blank");
               }}>
                    <img src="/images/metapyra.png" alt="Metapyra" />
               </button>}
          </>)
     }
}

export default WithRouterHooks(MetaPyra);
